import { METIERS } from './metiers.js';
import { $, el } from './dom.js';

export function renderEndServices() {
  const list = $('#endServices');
  if (!list) return;
  METIERS.forEach((m) => list.appendChild(el(`<li class="end__serv">${m.nom}</li>`)));
}

// Le sceau fixe en haut à gauche ne doit jamais passer sur le footer : on l'efface
// dès que le footer entre dans la bande haute de l'écran (sceau + marge d'avance,
// pour que le fondu soit terminé avant le chevauchement).
export function hideMarkOverFooter() {
  const mark = $('.mark');
  const end = $('.end');
  if (!mark || !end || !('IntersectionObserver' in window)) return;

  let io;
  const watch = () => {
    if (io) io.disconnect();
    const band = mark.getBoundingClientRect().bottom + window.innerHeight * .25;
    const below = Math.max(0, Math.round(window.innerHeight - band));
    io = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('is-footer', entry.isIntersecting);
    }, { rootMargin: `0px 0px -${below}px 0px` });
    io.observe(end);
  };

  watch();
  let raf;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(watch);
  });
}
